<template>
    <div class="category-cards">
        <div
            v-for="(category, index) in categories"
            :key="index"
            class="category-cards__category"
        >
            <h2 class="category-cards__title">{{ category.title }}</h2>
            <BaseGrid>
                <CategoryCard
                    v-for="(child, i) in category?.children"
                    :key="i"
                    :category="child"
                    :count="count"
                />
            </BaseGrid>
        </div>
    </div>
</template>

<script setup>
defineProps({
    categories: {
        type: Array,
        default: () => []
    },
    count: {
        type: Object,
        default() {
            return {};
        }
    }
});
</script>

<style lang="less" src="./CategoryCards.less" />
